export default {
    pageTitle: 'Horóscopo',
    extraChart: 'Mapas Extras',
    title: 'Horóscopo Personalizado',
    buttonTryAgain: 'Tentar novamente',
    seeCompleteHoroscope: 'Ver horóscopo completo',
    errorMessage: 'Não foi possível carregar suas influências diárias',
    subtitle: 'Veja suas influências diárias e saiba como os astros interagem com seu mapa astral',
    resumeSubTitle:
        '<small>Acompanhe suas influências diárias e saiba como o céu do momento interage com seu mapa astral.</small>',

    horoscopeError: {
        oops: '😨 Oops!',
        requestError:
            'Algo inesperado ocorreu ao carregar o horóscopo. <br /> Recarregue a página ou tente novamente mais tarde.'
    },

    influences: {
        singular: 'influência',
        plural: 'influências',
        viewInfluence: '<span>Ver influência</span>',
        viewInfluences: '<span>Ver influências</span>',
        viewFutureInfluences: '<span>Ver as <strong>{countInfluences}</strong> influências Futuras</span>',
        viewFutureInfluence: '<span>Ver influência Futura</span>',
        singularTitle: 'Você tem <strong>1 influência ativa</strong>',
        pluralTitle: 'Você tem <strong>{count} influências ativas</strong>',
        today: 'Hoje',
        emptyMessage: 'Não há <strong>influências ativas</strong> para hoje.',
        toSeeMoreInfluence: 'Ver mais <strong>1 influência</strong>',
        toSeeMoreInfluences: 'Ver mais <strong>{count} influências</strong>',
        toSeeMoreFutureInfluence: 'Ver influência futura',
        toSeeMoreFutureInfluences: 'Ver as <strong>{count}</strong> influências futuras',
        soonWillSee: '<br><p><strong>Logo poderá ver!</strong></p>'
    },

    optin: {
        notNow: 'Agora não',
        want: 'Quero receber',
        imgAlt: 'Ícone receber emails',
        wantMobile: 'RECEBER NOTIFICAÇÃO',
        dontMiss: 'Não perca mais as novidades que afetam no seu dia-a-dia!',
        informative: 'Saiba das mudanças de influências dos astros <strong>em você</strong> e outros eventos.'
    },

    redesign: {
        share: {
            message: 'Confira minhas recomendações do dia! ✨'
        },

        header: {
            title: 'Horóscopo',
            subtitle: 'A influência dos astros no seu dia',
            transitsMapLabel: 'Vendo o Horóscopo personalizado de:',

            menu: {
                future: 'Futuro',
                summary: 'Resumo',
                today: 'Trânsitos'
            }
        },

        summarizedHoroscope: {
            headlineLabel: 'RESUMO DE HOJE',
            explanation: 'Principais insights astrológicos para você hoje',
            viewCompleteTransitsButton: 'Ver trânsitos completos',
            lookingForClassicVersion: 'Procurando a versão clássica?',
            shareButton: 'Compartilhar',
            sharingButton: 'Compartilhando...',

            accordions: {
                love: 'Amor e Relacionamentos',
                money: 'Dinheiro e Carreira',
                social: 'Família e Amigos',
                health: 'Saúde e Bem-estar',
                spirituality: 'Espiritualidade',
                long: 'O seu período atual'
            }
        },

        coachmark: {
            intro: {
                title: 'Novidade no seu Horóscopo!',
                description: 'Vamos passar rapidamente pelas novas sessões 👉'
            },
            summary: {
                title: 'Resumo Inteligente',
                description: 'Todos os dias você receberá um resumo dividido em áreas da vida, com as principais atualizações filtradas entre todos os seus trânsitos 💗 💰 👩‍👶'
            },
            today: {
                title: 'Trânsitos',
                description: '<strong>A visualização clássica ainda está aqui!</strong> Esta sessão contém todos os seus trânsitos detalhados com casas, graus e duração 🤓'
            },
            future: {
                title: 'Futuro',
                description: 'Seus trânsitos programados para os próximos 4 dias aparecerão aqui 🔮<br />Boa leitura! 😉'
            },
            navigation: {
                previous: 'Anterior',
                next: 'Próximo',
                finish: 'Concluir'
            }
        }
    }
};
